import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

// Merchant session (Shopline OAuth returns merchant_id; demo seeds one)
export const getMerchantId = () => localStorage.getItem("vcoin_merchant_id");
export const setMerchantId = (id) => localStorage.setItem("vcoin_merchant_id", id);
export const getMerchantName = () => localStorage.getItem("vcoin_merchant_name") || "Merchant";
export const setMerchantName = (name) => localStorage.setItem("vcoin_merchant_name", name);
export const clearMerchant = () => {
  localStorage.removeItem("vcoin_merchant_id");
  localStorage.removeItem("vcoin_merchant_name");
};

export const CATEGORY_LABELS = {
  watch: "Watch",
  jewellery: "Jewellery",
  sneakers: "Sneakers",
  handbag: "Handbag",
  automotive: "Automotive",
  other: "Other",
};

export const CATEGORY_PRICE = {
  watch: "£19.99",
  automotive: "£19.99",
  jewellery: "£14.99",
  handbag: "£14.99",
  sneakers: "£14.99",
  other: "£2.99",
};

export const CATEGORY_PENCE = {
  watch: 1999,
  automotive: 1999,
  jewellery: 1499,
  handbag: 1499,
  sneakers: 1499,
  other: 299,
};

export const scoreColor = (score) => {
  if (score >= 80) return "#2D6A4F";
  if (score >= 50) return "#C9A84C";
  return "#C53030";
};

export const formatDate = (iso) => {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleDateString("en-GB", { day: "numeric", month: "short", year: "numeric" });
  } catch {
    return iso;
  }
};
